var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGnbTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck (3) 1",
    clipPath: "url(#clip0_12_6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0505 28.3332H8.44654C7.71188 28.3332 7.11321 27.7346 7.11321 26.9999V21.6665C7.11321 20.9305 6.51587 20.3332 5.77987 20.3332C5.04387 20.3332 4.44653 20.9305 4.44653 21.6665V26.9999C4.44653 29.2052 6.2412 30.9999 8.44654 30.9999H10.0505C10.6292 32.9199 12.3932 34.3332 14.4999 34.3332C16.6066 34.3332 18.3706 32.9199 18.9492 30.9999H24.4999H27.3839C27.9626 32.9199 29.7266 34.3332 31.8333 34.3332C33.9399 34.3332 35.7039 32.9199 36.2826 30.9999H39.1666C39.9026 30.9999 40.5 30.4026 40.5 29.6666V22.9999C40.5 22.0092 40.0853 20.6412 39.536 19.8172L35.6813 14.0359C35.0226 13.0492 33.6839 12.3332 32.4986 12.3332H28.7599V9.66651C28.7599 7.46117 26.9653 5.6665 24.7599 5.6665H20.4999C19.7639 5.6665 19.1666 6.26384 19.1666 6.99984C19.1666 7.73584 19.7639 8.33318 20.4999 8.33318H24.7613C25.4959 8.33318 26.0946 8.93185 26.0946 9.66651V28.3332H24.4999H18.9492C18.3706 26.4132 16.6066 24.9999 14.4999 24.9999C12.3932 24.9999 10.6292 26.4132 10.0505 28.3332ZM31.8333 31.6666C30.7306 31.6666 29.8333 30.7692 29.8333 29.6666C29.8333 28.5639 30.7306 27.6666 31.8333 27.6666C32.9359 27.6666 33.8333 28.5639 33.8333 29.6666C33.8333 30.7692 32.9359 31.6666 31.8333 31.6666ZM28.7613 14.9999H32.4999C32.7893 14.9999 33.3026 15.2745 33.4639 15.5159L35.7866 18.9999H28.7613V14.9999ZM28.7613 21.6665H37.5093C37.6906 22.0892 37.8333 22.6492 37.8333 22.9999V28.3332H36.2826C35.7039 26.4132 33.9399 24.9999 31.8333 24.9999C30.6519 24.9999 29.5839 25.4546 28.7613 26.1812V21.6665ZM16.4999 29.6666C16.4999 30.7692 15.6026 31.6666 14.4999 31.6666C13.3972 31.6666 12.4999 30.7692 12.4999 29.6666C12.4999 28.5639 13.3972 27.6666 14.4999 27.6666C15.6026 27.6666 16.4999 28.5639 16.4999 29.6666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8334 6.99984C17.8334 6.26384 17.236 5.6665 16.5 5.6665H1.83334C1.09733 5.6665 0.5 6.26384 0.5 6.99984C0.5 7.73584 1.09733 8.33318 1.83334 8.33318H16.5C17.236 8.33318 17.8334 7.73584 17.8334 6.99984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8332 13.6667C14.5692 13.6667 15.1665 13.0693 15.1665 12.3333C15.1665 11.5973 14.5692 11 13.8332 11H4.49984C3.76384 11 3.1665 11.5973 3.1665 12.3333C3.1665 13.0693 3.76384 13.6667 4.49984 13.6667H13.8332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.1666 19.0002C11.9026 19.0002 12.4999 18.4028 12.4999 17.6668C12.4999 16.9308 11.9026 16.3335 11.1666 16.3335H7.16659C6.43059 16.3335 5.83325 16.9308 5.83325 17.6668C5.83325 18.4028 6.43059 19.0002 7.16659 19.0002H11.1666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnbTruck);
export default __webpack_public_path__ + "static/media/icon-gnb-truck.b73d92a19619b6c6ff4f3dd731278948.svg";
export { ForwardRef as ReactComponent };